import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { Link } from "react-scroll";
//Images
import logo from '../../img/fav.png';
import shape from '../../img/footer-top-shape.png';
//CSS
import './style.css';
//
export default function Footer(props){
    const [menuList] = useState(props.menuList || [
        {
            url:'about',
            label:'About'
        },
        {
            url:'pricing',
            label:'Pricing'
        },
        {
            url:'pages',
            label:'Pages'
        },
        {
            url:'contact',
            label:'Contact'
        }
    ]);
    return(
        <>
            <div className="shape-img subscribe-wrap">
                <img alt="footer shape" src={shape} className="shape-img-bg img-fluid"/>
            </div>
            <footer className='footer-section w-100'>
                <div className="footer-top pt-5 pb-5 footer-bg">
                    <Container className="p-4">
                        <Row className="row justify-content-between">
                            <Col lg={3} mb={4} className="ml-auto mb-lg-0">
                                <div className="footer-nav-wrap text-white">
                                    <h5 className="mb-3 text-white">
                                        <img alt="logo" src={logo} width="30" height="30" className="d-inline-block align-top mr-2" />
                                        { props.branding }
                                    </h5>
                                    <p>{props.brandingText}</p>
                                    <div className="social-list-wrap">
                                        <ul className="social-list list-inline list-unstyled">
                                            <li className="list-inline-item"><a href={props.facebook}><span className="text-white"><FontAwesomeIcon icon={faFacebookF}/></span></a></li>
                                            <li className="list-inline-item"><a href={props.instagram}><span className="text-white"><FontAwesomeIcon icon={faInstagram}/></span></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} mb={4} className="ml-auto mb-lg-0">
                                <div className="footer-nav-wrap text-white">
                                    <h5 className="mb-3 text-white">Mapa do Site</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><Link to="home" spy={true} smooth={true} offset={-70} duration={500}>{ props.pageTitle || 'Home' }</Link></li>
                                        {menuList.map((item, i)=>
                                            <li key={i} className="mb-2"><Link to={ item.url } spy={true} smooth={true} offset={-70} duration={500}>{ item.label }</Link></li>
                                        )}
                                    </ul>
                                </div>
                            </Col>
                            <Col lg={3} mb={4} className="ml-auto mb-lg-0">
                                <div className="footer-nav-wrap text-white">
                                    <h5 className="mb-3 text-white">Onde Estamos</h5>
                                    <ul className="list-unstyled">
                                        {props.contactList.map((item, i)=>
                                            <li className="mb-2" key={i}>{item}</li>
                                        )}
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="footer-bottom gray-light-bg pt-4 pb-4">
                    <Container>
                        <Row className="text-center justify-content-center">
                            <Col md={6} lg={5}>
                                <p className="copyright-text pb-0 mb-0"><strong>EVOLUIR</strong> - 2020 Todos os direitos reservados</p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </footer>
        </>
    );
};